import React, { useEffect, useState } from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface LeaseLiabilityRommsProps {
  onBack?: () => void;
}

interface LeaseRommItem {
  id: string;
  risk: string;
  assertion: string;
  options: string[];
  workspace: string;
}

export default function LeaseLiabilityRomms({ onBack }: LeaseLiabilityRommsProps) {
  const workspace = "Lease Liability - Ind AS";
  const [rommsOverride, setRommsOverride] = useState<LeaseRommItem[]>([]);

  useEffect(() => {
    const loadRomms = async () => {
      const baseRomms: LeaseRommItem[] = [
        {
          id: "LEASE.SR.001",
          risk: "Lease liability does not exist and/or the entity does not have the rights or obligations.",
          assertion: "Existence, Rights & Obligations",
          options: ["Lower", "Higher", "Significant", "NRPMM"],
          workspace,
        },
        {
          id: "LEASE.SR.002",
          risk: "Lease liability is recorded at incorrect amount.",
          assertion: "Valuation",
          options: ["Lower", "Higher", "Significant", "NRPMM"],
          workspace,
        },
        {
          id: "LEASE.SR.003",
          risk: "Lease liability is incomplete.",
          assertion: "Completeness",
          options: ["Lower", "Higher", "Significant", "NRPMM"],
          workspace,
        },
        {
          id: "LEASE.SR.004",
          risk: "Lease liability is recorded in incorrect account.",
          assertion: "Classification",
          options: ["Lower", "Higher", "Significant", "NRPMM"],
          workspace,
        },
      ];

      let showNewAmendedLeaseRomm = false;
      try {
        const res = await (window as any)?.sharePointAPI?.downloadClientJson?.(
          "Execution_TailoringQuestions_Responses.json",
        );
        const answer =
          res?.data?.[workspace]?.["lease-ind-as-1"]?.selectedOption || "";
        showNewAmendedLeaseRomm =
          String(answer).trim().toLowerCase() === "yes";
      } catch {
        showNewAmendedLeaseRomm = false;
      }

      if (showNewAmendedLeaseRomm) {
        baseRomms.push({
          id: "LEASE.SR.005",
          risk: "New/amended lease liability: (1) does not exist, (2) is not the obligation of the entity, (3) is not recorded in the proper account, and/or (4) is recorded at the incorrect amount.",
          assertion: "Existence, Rights & Obligations, Classification, Valuation",
          options: ["Lower", "Higher", "Significant", "NRPMM"],
          workspace,
        });
      }

      setRommsOverride(baseRomms);
    };

    loadRomms();
  }, []);

  return (
    <PayrollRomms
      onBack={onBack || (() => {})}
      onComplete={() => {}}
      workspace={workspace}
      rommsOverride={rommsOverride}
    />
  );
}
